module.exports = __webpack_public_path__ + "img/streamline-icon-business-peak@450x450.612cdc90.svg";